import React from "react";
import { observer } from "mobx-react";
import { AiSearchPatternCreateStore } from "../../store";
import { AiSearchPatternCreateForm } from "./AiSearchPatternCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type AiSearchPatternCreateProps = {
  aiSearchPatternCreateStore: AiSearchPatternCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const AiSearchPatternCreate: React.FC<AiSearchPatternCreateProps> =
  observer(
    ({ aiSearchPatternCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={aiSearchPatternCreateStore.isSaving} />
          <AiSearchPatternCreateForm
            aiSearchPatternCreateStore={aiSearchPatternCreateStore}
            nameError={aiSearchPatternCreateStore.errors.name?.message}
            onNameChange={(value: string) => {
              aiSearchPatternCreateStore.setNameValue(value);
            }}
            name={aiSearchPatternCreateStore.entityValues.name}
            descriptionError={
              aiSearchPatternCreateStore.errors.description?.message
            }
            onDescriptionChange={(value: string) => {
              aiSearchPatternCreateStore.setDescriptionValue(value);
            }}
            description={aiSearchPatternCreateStore.entityValues.description}
            patternError={aiSearchPatternCreateStore.errors.pattern?.message}
            onPatternChange={(value: string) => {
              aiSearchPatternCreateStore.setPatternValue(value);
            }}
            pattern={aiSearchPatternCreateStore.entityValues.pattern}
            pathTypesError={
              aiSearchPatternCreateStore.errors.pathTypes?.message
            }
            onPathTypesChange={(value: string[]) => {
              aiSearchPatternCreateStore.setPathTypesValue(value);
            }}
            pathTypes={aiSearchPatternCreateStore.entityValues.pathTypes}
            toolsError={aiSearchPatternCreateStore.errors.tools?.message}
            onToolsChange={(value: string[]) => {
              aiSearchPatternCreateStore.setToolsValue(value);
            }}
            tools={aiSearchPatternCreateStore.entityValues.tools}
            effectivenessError={
              aiSearchPatternCreateStore.errors.effectiveness?.message
            }
            onEffectivenessChange={(value: number | undefined) => {
              aiSearchPatternCreateStore.setEffectivenessValue(value);
            }}
            effectiveness={
              aiSearchPatternCreateStore.entityValues.effectiveness
            }
            evaluationCountError={
              aiSearchPatternCreateStore.errors.evaluationCount?.message
            }
            onEvaluationCountChange={(value: number) => {
              aiSearchPatternCreateStore.setEvaluationCountValue(value);
            }}
            evaluationCount={
              aiSearchPatternCreateStore.entityValues.evaluationCount
            }
            successCountError={
              aiSearchPatternCreateStore.errors.successCount?.message
            }
            onSuccessCountChange={(value: number) => {
              aiSearchPatternCreateStore.setSuccessCountValue(value);
            }}
            successCount={aiSearchPatternCreateStore.entityValues.successCount}
            sourceEvalIdsError={
              aiSearchPatternCreateStore.errors.sourceEvalIds?.message
            }
            onSourceEvalIdsChange={(value: string[]) => {
              aiSearchPatternCreateStore.setSourceEvalIdsValue(value);
            }}
            sourceEvalIds={
              aiSearchPatternCreateStore.entityValues.sourceEvalIds
            }
            proposedByError={
              aiSearchPatternCreateStore.errors.proposedBy?.message
            }
            onProposedByChange={(value: string) => {
              aiSearchPatternCreateStore.setProposedByValue(value);
            }}
            proposedBy={aiSearchPatternCreateStore.entityValues.proposedBy}
            activeError={aiSearchPatternCreateStore.errors.active?.message}
            onActiveChange={(value: boolean) => {
              aiSearchPatternCreateStore.setActiveValue(value);
            }}
            active={aiSearchPatternCreateStore.entityValues.active}
            priorityError={aiSearchPatternCreateStore.errors.priority?.message}
            onPriorityChange={(value: number) => {
              aiSearchPatternCreateStore.setPriorityValue(value);
            }}
            priority={aiSearchPatternCreateStore.entityValues.priority}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={aiSearchPatternCreateStore.isProcessing}
            onSave={() => aiSearchPatternCreateStore.saveNewAiSearchPattern()}
            onCancel={() =>
              aiSearchPatternCreateStore.cancelNewAiSearchPattern()
            }
          />
          <ErrorDialog
            open={aiSearchPatternCreateStore.errorDialogOpened}
            title={aiSearchPatternCreateStore.errorTitle}
            description={aiSearchPatternCreateStore.errorDescription}
            onClose={() => aiSearchPatternCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
